import { useEffect } from 'react';
import { PageContainer } from '../../containers/PageContainer/PageContainer';
import { Copy } from '../../copy/Copy';
import { useNavigate } from 'react-router-dom';
import { APP_PATHS } from '../../constants/paths';

export const Admin = () => {
  const isAdmin = false;
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAdmin) {
      navigate(APP_PATHS.profile);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdmin]);

  return <PageContainer title={Copy.generate('Global.admin')}></PageContainer>;
};
